import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Stack,
  Switch,
  FormControlLabel,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  tlmPostNewPlantNote,
  tlmGetPlantNotes,
} from "layouts/dashboard/apiService";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPin";
import { APIStatusDialog } from "components/APIStatusDialog";
import { I18n } from "aws-amplify/utils";
import { useRefresh } from "layouts/dashboard/RefreshContext";

export const AddNewPlantNoteDialog = ({
  open,
  onClose,
  accountNumber,
  dispatchNotePlant,
  startDate,
  endDate,
}) => {
  const [note, setNote] = useState("");
  const [isPinned, setIsPinned] = useState(false);
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });

  const {handleRefresh}=useRefresh();
  // Resetta i campi ogni volta che il pop-up viene aperto
  useEffect(() => {
    if (open) {
      setNote("");
      setIsPinned(false);
    }
  }, [open]);

  const handleSaveNote = async () => {
    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Adding Store Note"),
      });

      const restOperation = await tlmPostNewPlantNote(
        accountNumber,
        isPinned,
        note
      );
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Added Store Note successfully"),
        });

        // Re-fetch the plant notes after saving
        const response = await tlmGetPlantNotes(
          accountNumber,
          endDate,
          startDate
        );
        dispatchNotePlant({ type: "DATA_RECEIVED", value: response });
        
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Error adding store note"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
      onClose(); // Chiudi il pop-up dopo il salvataggio
      handleRefresh();
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Error adding store note"),
      });

      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    }
  };

  const handlePinChange = (event) => {
    setIsPinned(event.target.checked);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{I18n.get("Add a New Store Note")}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={I18n.get("Note")}
          fullWidth
          multiline
          maxRows={6}
          minRows={2}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
        {/* Stack per organizzare lo switch e le icone */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="left"
          sx={{ mt: 2, pb: 0 }}
        >
          <Tooltip title={I18n.get("Unpin")}>
            <IconButton sx={{ mr: 1 }}>
              <PushPinOutlinedIcon />
            </IconButton>
          </Tooltip>
          <FormControlLabel
            control={<Switch checked={isPinned} onChange={handlePinChange} />}
            label=""
          />
          <Tooltip title={I18n.get("Pin")}>
            <IconButton sx={{ ml: -2 }}>
              <PushPinIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {I18n.get("Cancel")}
        </Button>
        <Button onClick={handleSaveNote} color="primary">
          {I18n.get("Save")}
        </Button>
      </DialogActions>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </Dialog>
  );
};
